export function initHeaderScrollHide(selector = '#header') {
  const header = document.querySelector(selector);
  if (!header) return; // тихо виходимо, якщо хедера немає

  // не ініціалізуємо двічі на одній сторінці
  if (header.dataset.scrollHideInitialized === 'true') return;
  header.dataset.scrollHideInitialized = 'true';

  let lastScrollTop = 0;
  let isHeaderHidden = false;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100 && !isHeaderHidden) {
      // Скролимо вниз і вже пройшли 100px - ховаємо хедер
      header.style.transform = 'translateY(-100%)';
      isHeaderHidden = true;
    } else if (scrollTop < lastScrollTop && isHeaderHidden) {
      // Скролимо вгору - показуємо хедер
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
    } else if (scrollTop <= 100 && isHeaderHidden) {
      // Дійшли до верху сторінки - завжди показуємо хедер
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  });
}
